import './es.object.to-string-2822ee1b.js';
import { f as computed, u as useConverter } from './runtime-core.esm-bundler-f5bc4aa7.js';
import { s as script$1 } from './Input-355815cc.js';
import { s as script$2 } from './Select-191fbc9e.js';
import { s as script$3 } from './Checkbox-5cb779a3.js';
import { s as script$4 } from './TextArea-f705f377.js';
import { t as toRefs, r as ref } from './reactivity.esm-bundler-12dbef55.js';
import './index-f674799c.js';
import './web.dom-collections.iterator-71bdf1d5.js';
import { resolveComponent, openBlock, createElementBlock, normalizeClass, Fragment, renderList, createVNode, createElementVNode, toDisplayString } from 'vue';

var script = {
  name: "form-control-attribute",
  emits: ["validate"],
  components: {
    FormControlInput: script$1,
    FormControlSelect: script$2,
    FormControlCheckbox: script$3,
    FormControlTextarea: script$4
  },
  props: {
    fields: {
      required: true,
      type: Array
    },
    groupName: {
      required: false,
      type: String,
      default: ""
    },
    parentFormId: {
      required: false,
      type: String,
      default: ""
    },
    elementPrefixId: {
      required: false,
      type: String,
      default: "wdw-bms-attr"
    },
    serverErrors: {
      required: false,
      type: Object,
      default: function _default() {
        return {};
      }
    },
    requiredIfResults: {
      required: false,
      type: Object,
      default: function _default() {
        return {};
      }
    },
    visibleIfResults: {
      required: false,
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // if true, it will show the fields in 2-column layout
    showInputAsCols: {
      required: false,
      type: Boolean,
      default: false
    },
    // Will override existing defaultvalues from the attribute itself if exist
    initialValues: {
      required: false,
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // If initial value is found, hide the input field to avoid further change
    hideOnInitialValueFound: {
      required: false,
      type: Boolean,
      default: false
    },
    resetCounters: {
      // resetCounters/reload on every field
      required: false,
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(props, context) {
    var _toRefs = toRefs(props),
        groupName = _toRefs.groupName,
        elementPrefixId = _toRefs.elementPrefixId,
        initialValues = _toRefs.initialValues,
        hideOnInitialValueFound = _toRefs.hideOnInitialValueFound;

    var allAttributeValuesByCode = ref({}); //+---------------------------+
    //|         computed1         |
    //+---------------------------+
    // const user = computed(() => {
    //   return userStore.getState().user;
    // });
    // const isLoggedIn = computed(() => {
    //   return userStore.isLoggedIn();
    // });
    //+--------------------------+
    //|     other methods        |
    //+--------------------------+

    var attributeId = function attributeId(attr) {
      return "attribute-" + attr.id;
    };

    var _useConverter = useConverter(),
        toBool = _useConverter.toBool,
        toArray = _useConverter.toArray;

    var getDefaultValue = function getDefaultValue(attr) {
      var attrid = attributeId(attr);
      var overrideInit = initialValues.value;
      return overrideInit[attrid] ? overrideInit[attrid] : attr.default_value;
    };

    var attrMaxLength = function attrMaxLength(attr) {
      if (attr.max_length && attr.max_length > 0) {
        return attr.max_length;
      }

      return 524288;
    }; // Per T17350, whether or not to hide input field if initial value is found


    var hideInputFieldIfInitValueFound = function hideInputFieldIfInitValueFound(attr) {
      var attrid = attributeId(attr);
      var overrideVal = initialValues.value[attrid];
      return toBool(overrideVal && overrideVal != null && overrideVal !== '' && hideOnInitialValueFound.value);
    }; //+---------------------------+
    //|         computed2         |
    //+---------------------------+


    var groupId = computed(function () {
      return elementPrefixId.value + "-attributegroup-" + groupName.value;
    }); // const relevantFields = computed(() => {
    //     return props.fields.filter(relevantToUser).sort(function (a, b) {
    //         return a.ordering - b.ordering;
    //     });
    // })

    var onValidatedFormField = function onValidatedFormField(fieldValue) {
      // T22832: Save all validated attribute values
      if (fieldValue.code != null) {
        allAttributeValuesByCode.value[fieldValue.code] = fieldValue.value;
      } // Pass validation to the parent
      // NOTE: you can also pre-validate subgroup of attributes here before passing back to parent


      context.emit("validate", fieldValue);
    };

    return {
      // VARS
      allAttributeValuesByCode: allAttributeValuesByCode,
      // Computed
      groupId: groupId,
      // user,
      // isLoggedIn,
      // fields,
      // other methods
      hideInputFieldIfInitValueFound: hideInputFieldIfInitValueFound,
      attributeId: attributeId,
      toBool: toBool,
      toArray: toArray,
      getDefaultValue: getDefaultValue,
      attrMaxLength: attrMaxLength,
      // Listeners
      onValidatedFormField: onValidatedFormField
    };
  }
};

var _hoisted_1 = ["id"];
var _hoisted_2 = {
  key: 0
};
var _hoisted_3 = {
  key: 1
};
var _hoisted_4 = {
  key: 2
};
var _hoisted_5 = {
  key: 3
};
var _hoisted_6 = {
  key: 4
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_form_control_input = resolveComponent("form-control-input");

  var _component_form_control_select = resolveComponent("form-control-select");

  var _component_form_control_checkbox = resolveComponent("form-control-checkbox");

  var _component_form_control_textarea = resolveComponent("form-control-textarea");

  return openBlock(), createElementBlock("div", {
    id: $setup.groupId,
    class: normalizeClass($props.showInputAsCols ? 'row' : '')
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList($props.fields, function (attr_field) {
    return openBlock(), createElementBlock("div", {
      class: normalizeClass($props.showInputAsCols ? 'col-6' : ''),
      key: attr_field.id
    }, [attr_field.type == 'text' || attr_field.type == 'email' || attr_field.type == 'link' || attr_field.type == 'number' ? (openBlock(), createElementBlock("div", _hoisted_2, [createVNode(_component_form_control_input, {
      label: attr_field.name,
      type: attr_field.type,
      code: attr_field.code,
      name: $setup.attributeId(attr_field),
      required: $setup.toBool(attr_field.required_for_user),
      serverError: $props.serverErrors[$setup.attributeId(attr_field)],
      isPublic: $setup.toBool(attr_field.public),
      hidden: $setup.hideInputFieldIfInitValueFound(attr_field),
      error: attr_field.error,
      help: attr_field.help,
      defaultvalue: $setup.getDefaultValue(attr_field),
      visibleIfResult: $props.visibleIfResults[attr_field.code],
      parentFormId: $props.parentFormId,
      prefixId: $props.elementPrefixId,
      maxLength: $setup.attrMaxLength(attr_field),
      reload: $props.resetCounters[$setup.attributeId(attr_field)] || 0,
      onValidate: $setup.onValidatedFormField
    }, null, 8, ["label", "type", "code", "name", "required", "serverError", "isPublic", "hidden", "error", "help", "defaultvalue", "visibleIfResult", "parentFormId", "prefixId", "maxLength", "reload", "onValidate"])])) : attr_field.type == 'valuelist' || attr_field.type == 'select' ? (openBlock(), createElementBlock("div", _hoisted_3, [createVNode(_component_form_control_select, {
      label: attr_field.name,
      showLabel: true,
      required: $setup.toBool(attr_field.required_for_user),
      name: $setup.attributeId(attr_field),
      serverError: $props.serverErrors[$setup.attributeId(attr_field)],
      code: attr_field.code,
      isPublic: $setup.toBool(attr_field.public),
      hidden: $setup.hideInputFieldIfInitValueFound(attr_field),
      error: attr_field.error,
      help: attr_field.help,
      defaultvalue: $setup.toArray($setup.getDefaultValue(attr_field)),
      multiselect: attr_field.multiselect == 1,
      options: attr_field.values,
      prefixId: $props.elementPrefixId,
      visibleIfResult: $props.visibleIfResults[attr_field.code],
      onValidate: $setup.onValidatedFormField,
      parentFormId: $props.parentFormId,
      allowClear: true,
      reload: $props.resetCounters[$setup.attributeId(attr_field)] || 0,
      dependantvalues: $setup.allAttributeValuesByCode
    }, null, 8, ["label", "required", "name", "serverError", "code", "isPublic", "hidden", "error", "help", "defaultvalue", "multiselect", "options", "prefixId", "visibleIfResult", "onValidate", "parentFormId", "reload", "dependantvalues"])])) : attr_field.type == 'checkbox' ? (openBlock(), createElementBlock("div", _hoisted_4, [createVNode(_component_form_control_checkbox, {
      label: attr_field.name,
      required: $setup.toBool(attr_field.required_for_user),
      name: $setup.attributeId(attr_field),
      code: attr_field.code,
      isPublic: $setup.toBool(attr_field.public),
      hidden: $setup.hideInputFieldIfInitValueFound(attr_field),
      error: attr_field.error,
      serverError: $props.serverErrors[$setup.attributeId(attr_field)],
      help: attr_field.help,
      prefixId: $props.elementPrefixId,
      defaultvalue: $setup.toBool($setup.getDefaultValue(attr_field)),
      visibleIfResult: $props.visibleIfResults[attr_field.code],
      onValidate: $setup.onValidatedFormField,
      reload: $props.resetCounters[$setup.attributeId(attr_field)] || 0,
      parentFormId: $props.parentFormId
    }, null, 8, ["label", "required", "name", "code", "isPublic", "hidden", "error", "serverError", "help", "prefixId", "defaultvalue", "visibleIfResult", "onValidate", "reload", "parentFormId"])])) : attr_field.type == 'textarea' ? (openBlock(), createElementBlock("div", _hoisted_5, [createVNode(_component_form_control_textarea, {
      label: attr_field.name,
      name: $setup.attributeId(attr_field),
      required: $setup.toBool(attr_field.required_for_user),
      code: attr_field.code,
      isPublic: $setup.toBool(attr_field.public),
      hidden: $setup.hideInputFieldIfInitValueFound(attr_field),
      error: attr_field.error,
      defaultvalue: $setup.getDefaultValue(attr_field),
      serverError: $props.serverErrors[$setup.attributeId(attr_field)],
      help: attr_field.help,
      prefixId: $props.elementPrefixId,
      visibleIfResult: $props.visibleIfResults[attr_field.code],
      onValidate: $setup.onValidatedFormField,
      parentFormId: $props.parentFormId,
      maxLength: $setup.attrMaxLength(attr_field.max_length),
      reload: $props.resetCounters[$setup.attributeId(attr_field)] || 0,
      textLimitConfig: {
        maxCount: attr_field.max_length,
        cLimitText: 'Maximale Zeichenanzahl erreicht'
      }
    }, null, 8, ["label", "name", "required", "code", "isPublic", "hidden", "error", "defaultvalue", "serverError", "help", "prefixId", "visibleIfResult", "onValidate", "parentFormId", "maxLength", "reload", "textLimitConfig"])])) : (openBlock(), createElementBlock("div", _hoisted_6, [createElementVNode("i", null, "Unknown type \"" + toDisplayString(attr_field.type) + "\" for attribute \"" + toDisplayString(attr_field.code) + "\"!", 1)]))], 2);
  }), 128))], 10, _hoisted_1);
}

script.render = render;

export { script as s };
